<template>
  <div class="container" @touchstart="touchstart()" @touchmove="touchmove()" @touchend="touchend()">
    <div class="mainContainer">
      <div class="maintext" v-for="(item, index) in textOne" :key="index">{{ item }}</div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'fourthPage',
  data () {
    return {
      textOne: [],
      touching: false,
      startY: 0,
      isClick: false
    }
  },
  mounted () {
    setTimeout(() =>{
      this.textIn()
    }, 500)
  },
  methods: {
    textIn () {
      let text=[
        '绘制自己的人生山丘',
        '大约需要一分钟',
        '是你花费在我身上的时间',
        '使我变得如此珍贵'
      ]
      for(let i = 0; i < text.length; i++){
        setTimeout(()=>{
          this.textOne.push(text[i])
        }, i * 1000)
      }
      setTimeout(() =>{
        if(!this.isClick){
          this.isClick = true
          this.$router.replace({path:'/gaokao'});
        }
      }, 4500)
    },
    touchstart(e) {
      e = e || event
      if(!this.touching){
        this.startY = e.touches[0].pageY
        this.touching = true
      }
    },
    touchmove(e) {
      e = e || event
      e.preventDefault()
    },
    touchend (e) {
      e = e || event
      if(this.touching){
        this.touching = false
        let endY = e.changedTouches[0].pageY
        if(endY < this.startY){
          if(!this.isClick){
            this.isClick = true
            this.$router.replace({path:'/gaokao'});
          }
        }
      }
    }
  }
}
</script>
<style scoped>
.container{
  width: 100%;
  height: 100%;
  background-color: #fef8f1;
  margin: 0 auto;
  position: relative;
}
.mainContainer{
  width: 100%;
  position: absolute;
  top: 40%;
  left: 50%;
  transform: translate(-3.75rem, -1rem);
  text-align: center;
}
.maintext{
  font-size: 0.3rem;
  line-height: 0.7rem;
  width: 4.14rem;
  margin: 0 auto;
  letter-spacing: 0.02rem;
  animation: fadein 1s;
  color: #504e4a;
}
@keyframes fadein{
  0% {opacity: 0;}
  100% {opacity: 1;}
}
</style>

